import "twin.macro";

import React from "react";

import { Tab } from "@mui/material";
import { Tabs } from "@mui/material";

import { useSetLocation } from "@services/reactRouterDom";
import type { SetLocationValue } from "@services/reactRouterDom";

const NavTabs = ({
  value,
  options,
  nextLocation,
}: {
  value: string;
  options: { label: string; value: string }[];
  nextLocation: (val: string) => SetLocationValue;
}) => {
  const setLocation = useSetLocation();
  return (
    <Tabs
      value={value ?? ""}
      onChange={(_e, v) => setLocation(nextLocation(v))}
      tw="min-h-0"
      indicatorColor="secondary"
    >
      {options.map((option) => (
        <Tab
          key={option.value}
          label={option.label}
          value={option.value}
          tw="py-2 min-h-0 hover:text-neutral-600 tracking-wider"
        />
      ))}
    </Tabs>
  );
};

export default NavTabs;
